module.exports = __webpack_public_path__ + "img/icon-decades-of-experience.4f3b7bb4.png";